import getMascotsByBatch from '@cartwhl/common/api/getMascotsByBatch';
import getMotionsByGroup from '@cartwhl/common/api/getMotionsByGroup';
import type { MotionRecord } from '@cartwhl/common/api/getMotionsByGroup';

import type {
  AssetLibraryGroupDetailItem,
  AssetLibraryGroupDetailSelection,
} from './assetLibraryGroupDetail';
import {
  toMascotGroupDetailItem,
  toMotionGroupDetailItem,
} from './assetLibraryGroupDetail';
import { fetchProjectHistoryPage } from './assetLibraryProjectHistory';

export type GroupDetailPageResult = {
  items: AssetLibraryGroupDetailItem[];
  projectMotions: MotionRecord[];
  nextToken?: string;
};

export async function fetchGroupDetailPage(
  selection: AssetLibraryGroupDetailSelection,
  apiKey: string,
  nextToken?: string,
): Promise<GroupDetailPageResult> {
  if (selection.groupKind === 'mascot') {
    const { data, error } = await getMascotsByBatch(
      selection.groupID,
      apiKey,
      nextToken,
    );

    if (error) {
      throw new Error(error.message || 'Unable to load batch items.');
    }

    return {
      items: (data?.items ?? []).map(toMascotGroupDetailItem),
      projectMotions: [],
      nextToken: data?.nextToken,
    };
  }

  if (selection.groupKind === 'project') {
    const page = await fetchProjectHistoryPage(selection.groupID, nextToken);

    return {
      items: page.detailItems,
      projectMotions: page.projectMotions,
      nextToken: page.nextToken,
    };
  }

  const { data, error } = await getMotionsByGroup(
    selection.groupID,
    apiKey,
    nextToken,
  );

  if (error) {
    throw new Error(error.message || 'Unable to load batch items.');
  }

  return {
    items: (data?.items ?? []).map(toMotionGroupDetailItem),
    projectMotions: [],
    nextToken: data?.nextToken,
  };
}
